import { gql } from "@apollo/client";
//  ! mutation returns null in value
const UPDATE_USER = gql`
  mutation UpdateUser($name: String, $email: String, $phone: String) {
    updateUser(name: $name, email: $email, phone: $phone) {
      id
      name
      phone
      email
    }
  }
`;

//  ! mutation returns null in value
const CREATE_USER_ADDRESS = gql`
  mutation CreateUserAddress(
    $line_one: String!
    $line_two: String
    $city: String!
    $state: String!
    $country: String!
    $zipcode: String!
  ) {
    createUserAddress(
      line_one: $line_one
      city: $city
      state: $state
      country: $country
      zipcode: $zipcode
      line_two: $line_two
    ) {
      id
      line_one
      line_two
      city
      state
      country
      zipcode
    }
  }
`;

//  !Issue in mutation
//  ! mutation returns null in value which causes issue
const UPDATE_USER_ADDRESS = gql`
  mutation UpdateUserAddress(
    $address_id: Int!
    $line_one: String
    $line_two: String
    $city: String
    $state: String
    $country: String
    $zipcode: String
  ) {
    updateUserAddress(
      address_id: $address_id
      line_one: $line_one
      line_two: $line_two
      city: $city
      state: $state
      country: $country
      zipcode: $zipcode
    ) {
      id
      line_one
      line_two
      city
      state
      country
      zipcode
    }
  }
`;

const UPDATE_USER_PLANT_SUBSCRIPTION = gql`
  mutation UpdateUserPlantSubscription($user_subs_id: Int!, $status: Boolean!) {
    updateUserPlantSubscription(user_subs_id: $user_subs_id, status: $status) {
      id
      user_id
      plant_id
    }
  }
`;

export {
  UPDATE_USER,
  CREATE_USER_ADDRESS,
  UPDATE_USER_ADDRESS,
  UPDATE_USER_PLANT_SUBSCRIPTION,
};
